export default {
  Paused: 'Paused',
  Active: 'Active',
  Deleted: 'Deleted',
};
